import { CommonUtil } from '@utils/common/common';
import { integerFormatter, percentFormatter, currencyFormatter } from '@utils/common/formatter';
import { IExplorerKeywordType } from '@models/keyword/keywordModel';
import moment from 'moment';

export class keywordExplorerOption {
  explorerGridOption(responseData) {
    const _data: IExplorerKeywordType[] = CommonUtil.getArrayByValidate(responseData);
    const columns = [
      {
        name: 'Rank',
        selector: (row) => row.rank,
        cell: (row) => integerFormatter(row.rank),
        sortable: true,
      },
      {
        name: 'App',
        selector: (row) => row.appTitle,
        cell: (row, index, column, id) => (
          <div className="tbl-app">
            <span className="tbl-thimg">
              <img src={row.appIcon} />
            </span>
            <span className="tbl-txt">{row.appTitle}</span>
          </div>
        ),
        sortable: true,
      },
      {
        name: 'Publisher',
        selector: (row) => row.publisher,
        sortable: true,
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      {
        name: 'Category',
        selector: (row) => row.category,
        sortable: true,
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      {
        name: (
          <div>
            Avg
            <br />
            Rating
          </div>
        ),
        selector: (row) => row.avgRating,
        cell: (row) => row.avgRating.toFixed(4),
        sortable: true,
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      {
        name: (
          <div>
            Rating
            <br />
            Count
          </div>
        ),
        selector: (row) => row.ratingCount,
        cell: (row) => integerFormatter(row.ratingCount),
        sortable: true,
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      {
        name: (
          <div>
            Included
            <br />
            Area
          </div>
        ),
        cell: (row, index, column, id) => (
          <div>
            {row.title && <span className="tb-icon-t">T</span>}
            {'  '}
            {row.subTitle && <span className="tb-icon-s">S</span>}
            {'  '}
            {row.description && <span className="tb-icon-d">D</span>}
          </div>
        ),
        // selector: row => row.avgRating,
        // sortable: true,
      },
      {
        name: 'Last Update',
        selector: (row) => row.date,
        cell: (row) => moment(row.date).format('YYYY-MM-DD'),
        sortable: true,
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      {
        name: 'D/L',
        selector: (row) => row.download,
        cell: (row) => integerFormatter(row.download),
        sortable: true,
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      {
        name: 'Rev.',
        selector: (row) => row.revenue,
        cell: (row) => currencyFormatter(row.revenue),
        sortable: true,
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    ];

    return {
      data: _data,
      columns,
    };
  }
}
